"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationResponseToJSON = exports.ReservationResponseFromJSONTyped = exports.ReservationResponseFromJSON = exports.instanceOfReservationResponse = void 0;
var runtime_1 = require("../runtime");
var Reservation_1 = require("./Reservation");
/**
 * Check if a given object implements the ReservationResponse interface.
 */
function instanceOfReservationResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfReservationResponse = instanceOfReservationResponse;
function ReservationResponseFromJSON(json) {
    return ReservationResponseFromJSONTyped(json, false);
}
exports.ReservationResponseFromJSON = ReservationResponseFromJSON;
function ReservationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'reservations': !(0, runtime_1.exists)(json, 'reservations') ? undefined : (json['reservations'].map(Reservation_1.ReservationFromJSON)),
    };
}
exports.ReservationResponseFromJSONTyped = ReservationResponseFromJSONTyped;
function ReservationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reservations': value.reservations === undefined ? undefined : (value.reservations.map(Reservation_1.ReservationToJSON)),
    };
}
exports.ReservationResponseToJSON = ReservationResponseToJSON;
